import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators, ɵFormGroupRawValue, ɵTypedOrUntyped} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReferenceBookType, RefundResponse} from '@npck/af-frontend-api';
import {REJECT_COMMENT_MAX_LENGTH} from '../../../../domain/constants';

@Component({
    selector: 'af-refund-reject-dialog',
    standalone: false,
    templateUrl: './refund-reject-dialog.component.html',
})
export class RefundRejectDialogComponent {
    ReferenceBookType = ReferenceBookType;
    form: FormGroup<RefundRejectForm>;
    maxCommentLength = REJECT_COMMENT_MAX_LENGTH;
    filterBy: string[] = ['ALL'];
    rejectButtonLabel = '';
    title = '';
    subtitle = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: RefundRejectDialogData,
        public dialogRef: MatDialogRef<RefundRejectDialogComponent>,
        private formBuilder: FormBuilder,
    ) {
        const processingBin = this.dialogData.refund.processingBin;
        if (this.dialogData.refund.prosecutorOfficeBin === processingBin) {
            this.filterBy.push('PROSECUTOR_OFFICE');
            this.rejectButtonLabel = 'i18n_af_buttonReject';
            this.title = 'i18n_af_rejectRefundDialogTitle';
            this.subtitle = 'i18n_af_rejectRefundDialogSubtitle';
        } else if (this.dialogData.refund.senderBin === processingBin) {
            this.filterBy.push(...['SENDER', 'SENDER,RECEIVER']);
            this.rejectButtonLabel = 'i18n_af_buttonRejectExecution';
            this.title = 'i18n_af_rejectRefundExecutionDialogTitle';
            this.subtitle = 'i18n_af_rejectRefundExecutionDialogSubtitle';
        } else if (this.dialogData.refund.receiverBin === processingBin) {
            this.filterBy.push('SENDER,RECEIVER');
            this.rejectButtonLabel = 'i18n_af_buttonRejectExecutionConfirmation';
            this.title = 'i18n_af_rejectRefundExecutionConfirmationDialogTitle';
            this.subtitle = 'i18n_af_rejectRefundExecutionConfirmationDialogSubtitle';
        }

        this.form = this.formBuilder.group({
            reason: new FormControl(null, [Validators.required]),
            comment: new FormControl('', [Validators.required]),
        });
    }
}

export declare type RefundRejectFormValue = ɵTypedOrUntyped<RefundRejectForm, ɵFormGroupRawValue<RefundRejectForm>, any>;

export interface RefundRejectDialogData {
    refund: RefundResponse;
}

interface RefundRejectForm {
    reason: FormControl<string>;
    comment: FormControl<string>;
}
